//
import axios from 'axios'
import PrevisionModel from "@/models/HumanResource/HrPrevision"
import { getFetchDataFunction } from '../DataTableService'

/**
 * 
 */
const create = async data => {

    //
    try {

        //
        const response = await ( new PrevisionModel( data ) ).save()

        //
        return response
    } catch ( error ) {

        //
        return error.response
    }
}

/**
 * 
 */
const fetchAll = async () => {

    //
    try {

        //
        const response = await PrevisionModel.append( appends ).include( includes ).params({ get_all_results: true }).get()

        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

/**
 * 
 */
const fetchById = async id => {

    //
    try {

        //
        const response = await PrevisionModel.append( appends ).include( includes ).find( id )

        //
        return response
    } catch ( error ) {

        //
        return error.response
    }
}

/**
 * 
 */
const remove = async id => {
    try {

        //
        const response = await axios.delete( process.env.VUE_APP_API_ROUTE + '/hr_prevision/' + id )
        
        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

/**
 * 
 */
const update = async ( id, data ) => {
    try {

        //
        const response = await axios.patch( process.env.VUE_APP_API_ROUTE + '/hr_prevision/' + id, data )
        
        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

/**
 * 
 */
const appends = [
]

/**
 * 
 */
const includes = [
]

//
export default {
    create,
    fetchAll,
    fetchById,
    dtFetchData: getFetchDataFunction( process.env.VUE_APP_API_ROUTE + '/hr_prevision', includes, appends ),
    remove,
    update,
}
